<form (ngSubmit)="actionClick()" class="comment-form" tabindex="0">
    <sync-text-field *ngIf="anonymousNameChange.observers.length" label="Name" placeholder="Name"
        (valueChange)="anonymousNameInputChange($event)"
        [value]="anonymousName" inputSize="small" [dynamicMaxlength]="35" />

    <sync-textarea 
        [label]="label"
        [placeholder]="placeholder"
        [dynamicMaxlength]="contentLength"
        [rows]="2"
        [charCounter]="true"
        [formControl]="commentForm">
    </sync-textarea>

    <div class="comment-form-buttons">
        <sync-button
            *ngIf="cancel.observers.length"
            class="cancel-comment-button"
            type="flat"
            label="Cancel"
            [onClick]="cancelClick">
        </sync-button>
        <sync-button class="post-comment-button"
            [disabled]="disabledAction" nativeType="submit" type="filled"
            [label]="actionButtonLabel" [isLoading]="showActionLoading">
        </sync-button>
    </div>
</form>